import { useCallback, useContext, useEffect, useRef, useState } from "react";
import AppContext from "../../context/context";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CategorySkeleton from "../skeleton/category/category-skeleton";

export default function PostCategoryList() {
  const { WEBSITE_URL, PUBLIC_URL, currentLanguage, filters, setFilters } =
    useContext(AppContext);
  const [categories, setCategories] = useState([]);
  const [loader, setLoader] = useState(false);
  const { t } = useTranslation();
  const currentLanguageRef = useRef("");

  useEffect(() => {
    currentLanguageRef.current = currentLanguage;
  }, [currentLanguage]);
  const getCategories = useCallback(async () => {
    setLoader(true);
    try {
      await fetch(
        `${PUBLIC_URL}/api/post/categorieslist?lng=${currentLanguageRef.current}`
      )
        .then((respose) => {
          if (respose.ok) {
            return respose.json();
          }
          throw new Error("error");
        })
        .then((data) => {
          setCategories(data);
          setLoader(false);
        });
    } catch (error) {
      setLoader(false);
    }
  }, [PUBLIC_URL]);

  useEffect(() => {
    getCategories();
  }, [currentLanguage, getCategories]);

  return (
    <div className="p-[60px_15%] block">
      <div className="flex items-center justify-center">
        {loader === false ? (
          categories ? (
            categories.map((category, index) => {
              return (
                <Link
                  to={`/blog`}
                  className="inline-block w-full"
                  key={index}
                  onClick={() => {
                    setFilters({
                      ...filters,
                      postCategoryId: category.id,
                    });
                  }}
                >
                  {category.thumbnail && (
                    <div className="flex justify-center">
                      <img
                        src={`${WEBSITE_URL}/media/${category.thumbnail}`}
                        alt={category.name}
                      />
                    </div>
                  )}
                  <div className="flex justify-center">{category.name}</div>
                </Link>
              );
            })
          ) : (
            <>{t("no_category")}</>
          )
        ) : (
          <div className="flex">
            <CategorySkeleton count={5} />
          </div>
        )}
      </div>
    </div>
  );
}
